import { create } from 'zustand';

/**
 * Triggered by the axios response interceptor when the backend raises
 * `PLAN_LIMIT_EXCEEDED` (403). The reason carries the structured payload from
 * `plan_guard.py` so the modal can tell the user exactly which limit they
 * hit — e.g. "You're at 10/10 employees on Starter".
 *
 * Before this store existed, those errors were flattened to a generic
 * permission-denied toast and the user had no path forward. Now they land on
 * the upgrade flow with context intact.
 */
export interface UpgradeReason {
  resource: string;
  current: number;
  limit: number;
  plan: string;
}

interface UpgradeModalState {
  open: boolean;
  reason: UpgradeReason | null;
  trigger: (reason?: UpgradeReason | null) => void;
  close: () => void;
}

export const useUpgradeModalStore = create<UpgradeModalState>((set) => ({
  open: false,
  reason: null,
  trigger: (reason = null) => set({ open: true, reason }),
  close: () => set({ open: false, reason: null }),
}));
